import { render, staticRenderFns } from "./CreatePlaylist.vue?vue&type=template&id=96a46602&scoped=true&"
import script from "./CreatePlaylist.vue?vue&type=script&lang=js&"
export * from "./CreatePlaylist.vue?vue&type=script&lang=js&"
import style0 from "./CreatePlaylist.vue?vue&type=style&index=0&id=96a46602&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a46602",
  null
  
)

export default component.exports